import React, { cloneElement, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import { maskPhoneNumber } from 'utils/validators';
import { templateParser } from 'utils/formatString';

// Actions
import { showInvitationStatus, toggleIncomingInviteModal } from '../store/actions';

const ShowInvitationStatusHoc = ({ children }) => {
  const dispatch = useDispatch();
  const { incomingInvitation } = useSelector((state) => state.application);

  const { isShowInviteStatus, incomingInvite, ctn } = incomingInvitation;

  const maskedCellNumber = maskPhoneNumber(ctn);
  const currentDescription = templateParser(incomingInvite?.status?.description, { NUMBER: maskedCellNumber });

  const handleShowInviteBtnClick = useCallback(() => {
    dispatch(showInvitationStatus(false));
    dispatch(toggleIncomingInviteModal(true));
  }, []);

  return (
    cloneElement(children, {
      isShowInviteStatus,
      title: incomingInvite?.status?.title,
      description: currentDescription,
      buttonText: incomingInvite?.status?.buttonText,
      handleShowInviteBtnClick,
    })
  );
};

export { ShowInvitationStatusHoc };
